import { Flex, Tabs } from "antd";
import styled from "styled-components";

// 页面页签及其内部工作区共同占满可用高度，并隔离内容滚动。
export const EquipmentWorkspace = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
  flex-direction: column;
  overflow: hidden;

  .ant-tabs-tabpane-active {
    display: flex;
  }
`;

export const EquipmentPageTabs = styled(Tabs)`
  height: 100%;
  overflow: hidden;

  .ant-tabs-nav {
    margin-bottom: 8px;
  }

  .ant-tabs-content-holder,
  .ant-tabs-content,
  .ant-tabs-tabpane {
    height: 100%;
    overflow: hidden;
  }

  td {
    height: 1px;
  }
`;

// 台账主体采用左侧类目、右侧内容的横向分栏布局。
export const EquipmentWrap = styled(Flex)`
  height: 100%;
  min-height: 0;
  gap: 12px;
`;

// 左侧类目区域固定基础宽度，树主体独立滚动。
export const CategoryPanel = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 280px;
  min-width: 240px;
  max-width: 320px;
  min-height: 0;
  gap: 10px;
`;

export const CategoryTreeBody = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;

  > .ant-spin,
  > .wms-empty {
    margin: auto;
  }
`;

// 右侧内容区纵向排列类目摘要与设备工作区。
export const CategoryContentPanel = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  gap: 12px;
`;

export const CategoryDetailPanel = styled.div<{ $fill?: boolean }>`
  display: flex;
  flex: ${({ $fill }) => ($fill ? 1 : "0 0 auto")};
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  justify-content: flex-start;
  gap: 12px;
  overflow: auto;
  padding: 12px;
  border-radius: 6px;

  > .ant-spin,
  > .wms-empty {
    margin: auto;
  }
`;

export const EquipmentListPanel = styled.div`
  display: flex;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
`;
